import type { Schedule } from '@tsuyosa/types';

interface Props {
  schedule: Schedule;
  onClick: () => void;
}

function getDay(d: string)   { return new Date(d + 'T00:00:00').getDate().toString(); }
function getMonth(d: string) {
  return new Date(d + 'T00:00:00').toLocaleDateString('id-ID', { month: 'short' }).toUpperCase();
}

export function ScheduleCard({ schedule, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className="group w-full rounded-xl border px-4 py-3 text-left transition-all duration-200
                 hover:border-[#f472b6]/30 hover:shadow-[0_0_20px_rgba(244,114,182,0.1)]"
      style={{ background: 'var(--surface)', borderColor: 'var(--border)' }}
    >
      <div className="flex items-center gap-4">
        {/* Date block */}
        <div
          className="flex shrink-0 flex-col items-center rounded-lg px-3 py-2 text-center"
          style={{ background: 'var(--surface-hi)' }}
        >
          <span className="text-3xl font-bold leading-none text-white">{getDay(schedule.date)}</span>
          <span className="mt-0.5 text-[10px] uppercase text-white/40">{getMonth(schedule.date)}</span>
        </div>

        {/* Info */}
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-white">{schedule.title}</p>
          {schedule.venue && (
            <p className="mt-0.5 truncate text-xs text-white/40">{schedule.venue}</p>
          )}
        </div>

        {/* Arrow */}
        <span className="shrink-0 text-lg text-white/20 transition-colors group-hover:text-[#f472b6]">
          →
        </span>
      </div>
    </button>
  );
}
